import React, { useContext } from "react";
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { ThemeContext } from "../../context/ThemeContext";

const NoDataTable = ({ columns, data = [], noDataMessage = "No records available" }) => {
    const { darkMode } = useContext(ThemeContext)
    return (
        <Box sx={{ backgroundColor: darkMode ? "#151924" : "#fff", height: '100%' }}>
            <TableContainer sx={{ backgroundColor: darkMode ? "#151924" : "#fff", }}>
                <Table>
                    <TableHead>
                        <TableRow>{columns.map((column) => (<TableCell key={column.key} sx={{ fontSize: "0.85rem", fontWeight: 200, p: 1, backgroundColor: darkMode ? "#151924" : "#fff", cursor: "pointer",borderBottom: "1px solid rgba(224, 224, 224, 0.3)", borderRight: `1px solid ${darkMode ? "#444" : "var(--borderLight)"}`, }}>{column.title}</TableCell>))}</TableRow>
                    </TableHead>

                    <TableBody>
                        {data.length > 0 ? (data.map((row, rowIndex) => (
                            <TableRow key={rowIndex}>{columns.map((column) => (<TableCell key={`${rowIndex}-${column.key}`}>{row[column.key] || "-"}</TableCell>))}</TableRow>))
                        ) : (<TableRow><TableCell colSpan={columns.length} align="center" sx={{ padding: "20px", color: "gray", border: "none" }}>{noDataMessage}</TableCell></TableRow>)}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
};

export default NoDataTable;
